import { Colors } from '../themes/colors';
import { Box } from './Box';

export const Divider = ({ color = Colors.neutral_100, height = 2, marginVertical = 16 }) => (
  <Box height={height} backgroundColor={color} marginVertical={marginVertical} />
);
